define("shared/components/shared/video-player/controls", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class={{if @primaryClass @primaryClass "cPM--video__control"}} ...attributes>
    {{#if (has-block)}}
      {{yield (hash playButtonId=@playButtonId play=(action @play) pause=(action @pause) toggle=(action @toggle))}}
    {{else}}
      <button
        class="cPM--video__btn is--play eMM--control__btn qa--postmodal_video_btn"
        id={{@playButtonId}}
        onclick={{action @toggle}}
        tabIndex="0"
        type="button"
        {{on "keyup" @keyboardToggle}}
      >
        {{svg-jar "play" class="cPM--video__icon--play o--icon--md qa--video_play_btn"}}
        {{svg-jar "pause" class="cPM--video__icon--pause o--icon--md qa--video_pause_btn"}}
      </button>
    {{/if}}
  </div>
  */
  {
    "id": "XLChqozI",
    "block": "[[[11,0],[16,0,[52,[30,1],[30,1],\"cPM--video__control\"]],[17,2],[12],[1,\"\\n\"],[41,[48,[30,8]],[[[1,\"    \"],[18,8,[[28,[37,3],null,[[\"playButtonId\",\"play\",\"pause\",\"toggle\"],[[30,3],[28,[37,4],[[30,0],[30,4]],null],[28,[37,4],[[30,0],[30,5]],null],[28,[37,4],[[30,0],[30,6]],null]]]]]],[1,\"\\n\"]],[]],[[[1,\"    \"],[11,\"button\"],[24,0,\"cPM--video__btn is--play eMM--control__btn qa--postmodal_video_btn\"],[16,1,[30,3]],[16,\"onclick\",[28,[37,4],[[30,0],[30,6]],null]],[24,\"tabIndex\",\"0\"],[24,4,\"button\"],[4,[38,5],[\"keyup\",[30,7]],null],[12],[1,\"\\n      \"],[1,[28,[35,6],[\"play\"],[[\"class\"],[\"cPM--video__icon--play o--icon--md qa--video_play_btn\"]]]],[1,\"\\n      \"],[1,[28,[35,6],[\"pause\"],[[\"class\"],[\"cPM--video__icon--pause o--icon--md qa--video_pause_btn\"]]]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]]],[13]],[\"@primaryClass\",\"&attrs\",\"@playButtonId\",\"@play\",\"@pause\",\"@toggle\",\"@keyboardToggle\",\"&default\"],false,[\"if\",\"has-block\",\"yield\",\"hash\",\"action\",\"on\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/video-player/controls.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});